import { AiOutlineExclamationCircle } from 'react-icons/ai';

import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  margin-top: 80px;
`;

export const Text = styled.p`
  text-align: center;
  margin: 32px 15%;
`;

export const Icon = styled(AiOutlineExclamationCircle)`
  margin: 0 0 4px 0;
  font-size: 25px;
  width: 100%;
`;

export const Strong = styled.strong`
  font-weight: 600;
`;

export const SimpleButton = styled(Button)`
  width: 150px;
`;
